<template>
  <div id="header-sidenav-menu-mobile">
    <slot></slot>
    <component
      :is="`sidenav_menu_${headerMobileLayout}`"
      :config="styleMenu"
      :data="siteComponents"
      :is_public="isPreview"
      @clickLink="clickLink"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

const components = {
  sidenav_menu_01: () =>
    import(/* webpackChunkName: "sidenav_menu_01" */ "@components/header/widget/header_widget_menu_mobile/sidenavmenu/sidenav_menu_01_view.vue"),
  sidenav_menu_02: () =>
    import(/* webpackChunkName: "sidenav_menu_02" */ "@components/header/widget/header_widget_menu_mobile/sidenavmenu/sidenav_menu_02_view.vue"),
};

export default {
  props: {

  },
  components: {
    ...components,
  },
  computed: {
    ...mapGetters({
      isPreview: "designIframe/preview",
      siteComponents: "designIframe/metadata/siteComponents",
      sitePage: "designIframe/metadata/sitePage",
    }),
    styleMenu() {
      return this.siteComponents.HEADER_WIDGET_MENU.style;
    },
    headerMobileLayout() {
      return this.siteComponents.HEADER.styleMobile.layout == '01' ? '01' : '02';
    },
  },
  methods: {
    clickLink(linkProps, isEnableLink) {
      if (this.isPreview && isEnableLink) {
        switch (linkProps.type) {
          case "url": {
            if (this.checkCanClick(linkProps)) {
              let hrefFormat = this.$helper.url.genValidUrl(linkProps.url);
              window.open(hrefFormat, linkProps.target);
            }
            break;
          }
          case "page": {
            if (this.checkCanClick(linkProps)) {
              let metaDataID = this.siteComponents[linkProps.pageID].properties.metaDataID;
              if (this.sitePage.properties.metaDataID != metaDataID) {
                this.$store.dispatch("designIframe/page/getPage", {
                  metaDataID,
                });
              } else {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }
            }
            break;
          }
          case "onpage": {  // for header menu
            if (this.checkCanClick(linkProps)) {
              let metaDataID = this.siteComponents[linkProps.pageID].properties.metaDataID;
              let elementID = linkProps.sectionID;
              this.setNewHashJs(metaDataID, elementID);
              this.$store.dispatch("designIframe/page/getPage", {
                metaDataID,
                elementID,
              });
            }
            break;
          }
          default: {
            break;
          }
        }
      }
    },
    checkCanClick(linkProps) {
      if (linkProps.type == "url" && !linkProps.urlIsEnable) {
        return false;
      } else if (linkProps.type == "url" && linkProps.target == "_self") {
        alert('This link only work on your published website.')
        return false;
      } else if (linkProps.type == "page" && !linkProps.pageID) {
        return false;
      } else if (linkProps.type == "page" && linkProps.target == "_blank") {
        alert('This link only work on your published website.')
        return false;
      } else {
        return true;
      }
    },
    setNewHashJs(metaDataID, elementID = null) {
      let url = `#/page/${metaDataID}/anchor/${elementID}`;
      this.$store.dispatch(
        "designIframe/postToParent",
        {
          func: "component/setNewHashJs",
          payload: {
            url: url,
          },
        },
        { root: true }
      );
    },
  },
};
</script>

<style>

</style>
